import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { CurrencyInput } from 'ui-components/components/currency-input';
import { NumberInput } from 'ui-components/components/number-input';

import { useAddFundsModalContext } from './contexts/add-funds-modal-context-provider';
import AddFundsErrorSection from './error-section';
import messages from './messages';
import style from './style.module.less';
import FormattedCurrency from '../../../../components/formatted-currency';
import { CurrencyPropType } from '../../../../prop-types/currency';

const AutoFundsTab = ({ balance }) => {
  const {
    autoFundEnabled,
    setAutoFundEnabled,
    balanceThreshold,
    setBalanceThreshold,
    autoFundAmount,
    setAutoFundAmount,
    maxDailyFundings,
    setMaxDailyFundings,
    autoFundErrors: errors,
    submitting,
  } = useAddFundsModalContext();

  const toggleAutoFundEnabled = useCallback(() => setAutoFundEnabled((val) => !val), [setAutoFundEnabled]);

  const onArrowButtonPress = useCallback(
    (updatedValue) => {
      setMaxDailyFundings(updatedValue);
    },
    [setMaxDailyFundings],
  );

  const inputsDisabled = !autoFundEnabled || submitting;
  return (
    <div className={style['tab-content']}>
      {errors?.length > 0 && <AddFundsErrorSection currencyCode={balance?.code} errors={errors} />}
      <Checkbox
        checked={autoFundEnabled}
        disabled={submitting}
        inputId='enable-auto-funding-checkbox'
        label={<FormattedMessage {...messages.enableAutofund} />}
        largeCheckbox
        onChange={toggleAutoFundEnabled}
      />
      <div className={style.label}>
        <FormattedMessage {...messages.currentBalance} />
      </div>
      {balance ? <FormattedCurrency currencyCode={balance?.code} value={balance?.value} /> : <span>&mdash;</span>}
      <div className={style.label}>
        <FormattedMessage {...messages.balanceThreshold} />
      </div>
      <CurrencyInput
        className={style['currency-funds']}
        currencyCode={balance?.code}
        disabled={inputsDisabled}
        onChange={setBalanceThreshold}
        value={balanceThreshold}
      />
      <div className={style.label}>
        <FormattedMessage {...messages.autoFundAmount} />
      </div>
      <CurrencyInput
        className={style['currency-funds']}
        currencyCode={balance?.code}
        disabled={inputsDisabled}
        onChange={setAutoFundAmount}
        value={autoFundAmount}
      />
      <div className={style.label}>
        <FormattedMessage {...messages.maxFunding} />
      </div>
      <div className={style['max-funds-container']}>
        <NumberInput
          className={style['max-funds-input']}
          disabled={inputsDisabled}
          onArrowButtonPress={onArrowButtonPress}
          onChange={setMaxDailyFundings}
          value={maxDailyFundings}
        />
        <FormattedMessage {...messages.fundingPerDay} />
      </div>
    </div>
  );
};

AutoFundsTab.propTypes = {
  balance: CurrencyPropType.isRequired,
};

export default AutoFundsTab;
